module.exports = __webpack_public_path__ + "img/category-popular.2839a195.png";